module.exports = __webpack_public_path__ + "static/img/code.3fda32c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.png
// module id = EF7e
// module chunks = 1